import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import getStore from './store'
import getRoutes from './routes'

const store = getStore()
const { getState } = store

import {selectIsAuthenticated} from "common/redux/selectors/auth"
import {activateSegment} from "common/analytics"
import {setItemOnInitialLoad} from "common/redux/root"

const analyticsWrapper = () => {
  const envConfig = window.OD.initialState.env_config

  const isAuthenticated = selectIsAuthenticated(getState())

  const sourceKeyId = envConfig.SEGMENT_MANAGER_SOURCE_KEY

  if (sourceKeyId && !window.analytics && isAuthenticated) {
    activateSegment(sourceKeyId)
    // dispatches event once segment is initialized
    window.analytics.ready(() => {
      let segmentInitializationAttemptNumber = 0
      const initialSegmentAction = () => {
        segmentInitializationAttemptNumber += 1
        if (segmentInitializationAttemptNumber < 20) {
          setTimeout(initialSegmentAction, 500)
        } else {
          store.dispatch(
            setItemOnInitialLoad({})
          )
        }
      }

      initialSegmentAction()
    })
  } else if (sourceKeyId && !window.analytics) {
    activateSegment(sourceKeyId)
  }
}

analyticsWrapper()

render((<Provider store={store}>{ getRoutes(store) }</Provider>), document.getElementById('main'))
